import React, { useState, useEffect } from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { XTabNav } from '@/components/xqxc_ui';
import List from './list';
import About from './about';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import { connect } from 'react-redux';

const tabList = [
    { id: 1, label: '版本管理' },
    { id: 2, label: '关于我们' }
];

const Detail = ({
    history,
    setBreadcrumbPaths,
    match,
}) => {

    const [curTabID, setCurTabID] = useState(1);

    useEffect(() => {
        setBreadcrumbPaths(match); // 自动识别面包屑
    }, []);

    return <div className={styles.flexBoxContainer}>
        <XTabNav renderData={tabList} onChange={setCurTabID} activedID={curTabID} />
        {curTabID === 1 ? <List history={history} /> : <About />}
    </div>;
};

Detail.propTypes = {
    history: PropTypes.object,//路由对象
    match: PropTypes.object, // 路由match对象
    setBreadcrumbPaths: PropTypes.func,//面包屑导航信息
};

export default connect(null, { setBreadcrumbPaths })(Detail);